import ApiV1 from "@/configs/axios/ApiV1";
import { CancelRequest, GetCancelToken } from "@/configs/axios/Axios";
import PermissionsV1 from "@/router/permissions/v1";
import { HasPermissionOrThrow } from "@/utils/permisshoinHelper";

export function GetRatings(params = {}) {
  HasPermissionOrThrow(PermissionsV1["RATING.INDEX"]);
  CancelRequest("rating:index");

  return ApiV1.get("/ratings", {
    params,
    signal: GetCancelToken("rating:index"),
  });
}

// Преференции и заявки строки открываются по кнопке, поэтому в списке их нет:
// в одном ответе они стоили 23 запроса и 4 КБ на строку.
export function GetRatingPreferences(id) {
  HasPermissionOrThrow(PermissionsV1["RATING.PREFERENCES"]);
  CancelRequest("rating:preferences");

  return ApiV1.get(`/ratings/${id}/preferences`, {
    signal: GetCancelToken("rating:preferences"),
  });
}

export function GetRatingRequests(id, params = {}) {
  HasPermissionOrThrow(PermissionsV1["RATING.REQUESTS"]);
  CancelRequest("rating:requests");

  return ApiV1.get(`/ratings/${id}/requests`, {
    params,
    signal: GetCancelToken("rating:requests"),
  });
}

// Служебный путь после назначения из рейтинга (по данным HRMIS)
export function GetRatingExperiences(id) {
  HasPermissionOrThrow(PermissionsV1["RATING.EXPERIENCES"]);
  CancelRequest("rating:experiences");

  return ApiV1.get(`/ratings/${id}/experiences`, {
    signal: GetCancelToken("rating:experiences"),
  });
}

export function GetRatingStatuses() {
  HasPermissionOrThrow(PermissionsV1["RATING.STATUSES"]);
  return ApiV1.get("/ratings/statuses");
}

export function GetRatingTypes() {
  HasPermissionOrThrow(PermissionsV1["RATING.TYPES"]);
  return ApiV1.get("/ratings/types");
}

export function GetRatingDiplomaTypes() {
  HasPermissionOrThrow(PermissionsV1["RATING.DIPLOMA_TYPES"]);
  return ApiV1.get("/ratings/diploma-types");
}

export function GetRatingRoutes() {
  HasPermissionOrThrow(PermissionsV1["RATING.ROUTES"]);
  return ApiV1.get("ratings/routes");
}

export function UpdateRating(id, payload) {
  HasPermissionOrThrow(PermissionsV1["RATING.UPDATE"]);
  return ApiV1.post(`/ratings/${id}`, payload);
}

export function DownloadRatingReport(payload) {
  CancelRequest("rating:report:download");
  return ApiV1.post("/ratings/report/download", payload, {
    signal: GetCancelToken("rating:report:download"),
  });
}
